import React from 'react';
import { useState } from "react";
import { useSelector } from 'react-redux';
import {
    Box,
    Typography,
} from "@mui/material";
import CustomerDataGrid from './CustomerDataGrid';
import Page from '../../components/Page';
import { useCompanyMessages } from '../../hooks/useMessages';

const CustomersPage = () => {
    /// container page for Customer View. Displays all customers that have reached out to a processor
    const currentCompany = useSelector((state) => state.CompanyReducer.userCompanies[0]);
    const { data: allMessages = [] } = useCompanyMessages({
        companyId: currentCompany?.id,
        enabled: Boolean(currentCompany?.id),
    });

    return(
        <Page title="Customers">
        <Box style={{paddingRight:'30px'}}>
            <Box sx={{ marginTop: "10px", marginBottom: "10px" }}>
                <Typography textAlign={"center"} color={"blue"} variant='h4'>
                    Customers
                </Typography>
            </Box>
            <Box width='100%' textAlign="center">
                <Typography variant="h5" >
                </Typography>
            </Box>
            <CustomerDataGrid messages={allMessages}/>
        </Box>
        </Page>
    )
}

export default CustomersPage;